import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { networkErrorHandler } from 'utils/errrorHandlers';
import { startFetchCoupons, createCouponFailure, setAnyData } from '../actions';
import CouponsActionTypes from '../types';

const { API_BASE_URL } = urls || {};

function* createCoupon({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/coupons`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });
  if (response.success) {
    Notify(`Discount code Created Successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    yield cb();
    yield put(setAnyData({ saving: false }));
    yield put(startFetchCoupons({ currentPage: 0, pageSize: 10 }))
  } else {
    yield put(createCouponFailure(response.message));
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onCouponCreate() {
  yield takeLatest(CouponsActionTypes.START_CREATE_COUPON, createCoupon);
}
